var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 7.83301C10.8207 7.83301 7.83398 10.8197 7.83398 14.4997C7.83398 18.1797 10.8207 21.1663 14.5007 21.1663C18.1807 21.1663 21.1673 18.1797 21.1673 14.4997C21.1673 10.8197 18.1807 7.83301 14.5007 7.83301ZM17.1873 14.853L15.1873 16.853C15.0873 16.953 14.9607 16.9997 14.834 16.9997C14.7073 16.9997 14.5807 16.953 14.4807 16.853C14.2873 16.6597 14.2873 16.3397 14.4807 16.1463L15.6273 14.9997H12.1673C11.894 14.9997 11.6673 14.773 11.6673 14.4997C11.6673 14.2263 11.894 13.9997 12.1673 13.9997H15.6273L14.4807 12.853C14.2873 12.6597 14.2873 12.3397 14.4807 12.1463C14.674 11.953 14.994 11.953 15.1873 12.1463L17.1873 14.1463C17.3807 14.3397 17.3807 14.6597 17.1873 14.853Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigatorIcon);
export default __webpack_public_path__ + "static/media/navigatorIcon.d2f425fa4e5fa362f993a3380e89958f.svg";
export { ForwardRef as ReactComponent };